import React from 'react';
import { Hero } from '../components/Hero';
import { Logos } from '../components/Logos';
import { Problem } from '../components/Problem';
import { CastingCalls } from '../components/CastingCalls';
import { RosterDatabase } from '../components/RosterDatabase';
import { Audiences } from '../components/Audiences';
import { ProductWorkflow } from '../components/ProductWorkflow';
import { Moat } from '../components/Moat';
import { CTA } from '../components/CTA';
import { InfluencerHub, CapterraReviews, Newsletter, CreatorAssetOS } from '../components/HomeExtras';
import { Testimonials, BRAND_TESTIMONIALS } from '../components/Testimonials';
export const Home = () => {
  return <>
      <Hero data-id="element-2059" />
      <Logos data-id="element-2060" />
      <Problem data-id="element-2061" />
      <CastingCalls data-id="element-2062" />
      <RosterDatabase data-id="element-2063" />
      <Audiences data-id="element-2064" />
      <ProductWorkflow data-id="element-2065" />
      <Moat data-id="element-2066" />
      <Testimonials title="Loved by top brands and agencies" items={BRAND_TESTIMONIALS} data-id="element-2067" />
      <InfluencerHub data-id="element-2068" />
      <CapterraReviews data-id="element-2069" />
      <CreatorAssetOS data-id="element-2070" />
      <CTA data-id="element-2071" />
      <Newsletter data-id="element-2072" />
    </>;
};